import AnalyticsTwoIcon from "../../../../../../../assets/svg/analytics-two-icon";
import ChartCard, { ChartEmptyState } from "./ChartCard";

export interface IssueTypeDataItem {
  title: string;
  system: string;
  count: number;
}

interface TopIssueTypesListProps {
  data: IssueTypeDataItem[];
}

const TopIssueTypesList = ({ data }: TopIssueTypesListProps) => (
  <ChartCard
    title="Top Issue Types"
    description="Most common support issues"
    headerIcon={<AnalyticsTwoIcon className="w-4 h-4 text-verba-indigo dark:text-verba-indigo-dk" />}
    className="h-[286px]"
  >
    {data?.length === 0 ? (
      <ChartEmptyState />
    ) : (
      <div className="flex flex-col gap-2 overflow-y-auto" style={{ maxHeight: 310 }}>
        {data?.map((item, idx) => (
          <div
            key={idx}
            className="bg-pure-white dark:bg-pure-white-dk border border-border-gray dark:border-border-gray-dk rounded-[10px] flex items-center justify-between px-3 py-2 shrink-0"
          >
            <div className="flex flex-col gap-0.5 min-w-0 mr-3">
              <p className="text-md font-medium text-heading-text dark:text-heading-text-dk truncate">
                {item?.title}
              </p>
              <p className="text-md text-dark-gray dark:text-dark-gray-dk">
                {item?.system}
              </p>
            </div>
            <span className="shrink-0 bg-applied-filters-tag-bg dark:bg-applied-filters-tag-bg-dk text-verba-blue dark:text-verba-blue text-md font-semibold rounded-full px-2 py-1 leading-5">
              {item?.count}
            </span>
          </div>
        ))}
      </div>
    )}
  </ChartCard>
);

export default TopIssueTypesList;
